import { isSuccess } from '@devexperts/remote-data-ts'
import { DateTime } from 'luxon'
import { useEffect, useMemo } from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'

import { INSERT_PERIOD_PATH } from '@/app/router/paths.ts'
import { useAppDispatch, useAppSelector } from '@/hooks/store.ts'
import { useAppPath } from '@/hooks/useAppPath'
import { cartSlice } from '@/store/cartSlice/index.ts'
import { insertPeriodSlice } from '@/store/insertPeriodSlice.ts'

export function PeriodProtectedRoute() {
  const period = useAppSelector(insertPeriodSlice.selectors.period)
  const quoteTotal = useAppSelector(cartSlice.selectors.quoteTotal)
  const [searchParams] = useSearchParams()
  const insertPeriodPath = useAppPath(INSERT_PERIOD_PATH)
  const quoteWithDiscount = useAppSelector(
    cartSlice.selectors.quoteWithDiscount
  )
  const dispatch = useAppDispatch()

  useEffect(() => {
    // This useEffect is useful because it allows you to remove the discount
    // code in the store whenever the total price
    // of the cart changes after the discount code has already been applied

    if (isSuccess(quoteWithDiscount)) {
      dispatch(cartSlice.actions.resetDiscount())
    }
  }, [quoteTotal])

  const isValidPeriod = useMemo(() => {
    if (!period?.end || !period.start) {
      return false
    }

    const start = DateTime.fromISO(period.start).toUnixInteger()
    const end = DateTime.fromISO(period.end).toUnixInteger()

    if (start > end) {
      return false
    }

    const nowStart = DateTime.now().startOf('day').toUnixInteger()
    if (nowStart > start) {
      return false
    }

    return true
  }, [period])

  return isValidPeriod ? (
    <Outlet />
  ) : (
    <Navigate to={`${insertPeriodPath}?${searchParams.toString()}`} />
  )
}
